<template>
  <div>
    <div ref="popupContent">
      <template v-if="detailInfo.deviceNumber">
        <map-dialog class="device-info-popup" :disabled="true" :detailInfo="detailInfo" @updateValveStatus="updateValveStatus"></map-dialog>
      </template>
    </div>
  </div>
</template>

<script>
// import vjmap from 'vjmap'
import MapDialog from '../device/MapDialog'
import { getMapIcon } from '@/views/device/mapIcon'
export default {
  name: 'IrrigationCenter',
  components: { MapDialog },
  data () {
    return {
      // 设备弹框信息
      detailInfo: {}
    }
  },
  filters: {},
  watch: {
    '$route.path' (newPath, oldPath) {
      // 路由变化时的处理逻辑
      console.log('路由从', oldPath, '变化到', newPath)
      this.clearMap()
      this.initMap()
    }
  },
  computed: {
    projectId () {
      return this.$store.state.projectId || ''
    },
    // 是否有cad
    isCad () {
      return this.$store.getters.isCad === '1'
    }
  },
  created () {
    // 喷灌区域列表详情点击监听
    this.$event.$on('areaList-item-checked', (areaId) => {
      if (areaId) {
        this.initAreaInfo(areaId)
      } else {
        this.removeMarkers()
      }
    })
    this.initMap()
  },
  destroyed () {
    this.$event.$off('areaList-item-checked')
    this.clearMap()
  },
  methods: {
    clearMap () {
      this.removeMarkers()
    },
    initMap () {
      if (this._map) {
        this.mapAction()
      } else {
        const interval = setInterval(() => {
          this._map = this.$parent.$children[0]._map
          if (this._map) {
            interval && clearInterval(interval)
            this.mapAction()
          }
        }, 200)
      }
    },
    // 获取区域详情
    loadAreaDetail (areaId) {
      return this.$axios.get(this.$apis.irrigation.selectJgIrrigationAreaByAreaId, {
        areaId
      })
    },
    mapAction () {
      // 喷灌区域新增
      if (this.isAreaAdd) {
        this.initAreaUpdate()
      }
    },
    // 添加区域管理 地图上相关信息
    initAreaInfo (areaId) {
      this.removeMarkers()
      this.loadAreaDetail(areaId).then(res => {
        this.addAreaDeviceMarkers(res.valveObjList || [], 'Valve')
        this.addAreaDeviceMarkers(res.soilObjList || [], 'Soil')
        this.addAreaDeviceMarkers(res.waterObjList || [], 'Water')
        this.addAreaDeviceMarkers(res.electricityObjList || [], 'Electricity')
        this.addAreaDeviceMarkers(res.waterLyObjList || [], 'liuya')
      })
    },
    // 获取点位图标
    getIcon (data, type) {
      let iconPath = ''
      if (!data.deviceNumber) {
        iconPath = require('../../assets/img/mapIcon/noBindDevice.svg')
      } else {
        iconPath = require('../../assets/img/icon/valve.png')
      }
      if (type === 'Valve') {
        iconPath = require(`../../assets/img/icon/valve${data.switchStatus !== '1' ? '_close' : ''}.png`)
      } else if (type === 'Soil') {
        iconPath = getMapIcon('1001', data)
      } else if (type === 'Water') {
        iconPath = require(`../../assets/img/mapIcon/device_1004_${data.deviceStatus === '1' ? '1' : '2'}.svg`)
      } else if (type === 'Electricity') {
        iconPath = require(`../../assets/img/mapIcon/device_1014_${data.deviceStatus === '1' ? '1' : '2'}.svg`)
      } else if (type === 'liuya') {
        iconPath = getMapIcon('liuya', data)
      }
      return iconPath
    },
    // 获取点位信息
    getMarkerEl (iconPath, w, h) {
      const el = document.createElement('div')
      el.className = 'marker'
      el.style.backgroundImage = `url(${iconPath})`
      el.style.width = w || '40px'
      el.style.height = h || '40px'
      el.style.backgroundSize = '100%'
      return el
    },
    // 喷灌区域设备地图标记
    addAreaDeviceMarkers (list, type) {
      if (this.isCad) {
        list.forEach(item => {
          if (item.objectX && item.objectY) {
            const cadPoints = vjmap.geoPoint([item.objectX, item.objectY])
            const lngLat = this.$parent.$children[0].cadToWebCoordinate(cadPoints)
            const el = this.getMarkerEl(this.getIcon(item, type), '36px', '48px')
            const marker = new vjmap.Marker({
              element: el,
              anchor: 'bottom'
            })
            marker.extData = { ...item }
            marker.setLngLat(lngLat).addTo(this._map)
            marker.on('click', this.deviceMarkerClick)
            this._areaDeviceMarkers.push(marker)
          }
        })
      } else {
        list.forEach(item => {
          if (item.longitude && item.latitude) {
            const lngLat = new vjmap.LngLat(item.longitude, item.latitude)
            const el = this.getMarkerEl(this.getIcon(item, type), '36px', '48px')
            const marker = new vjmap.Marker({
              element: el,
              anchor: 'bottom'
            })
            marker.extData = { ...item }
            marker.setLngLat(lngLat).addTo(this._map)
            marker.on('click', this.deviceMarkerClick)
            this._areaDeviceMarkers.push(marker)
          }
        })
      }
      this.$parent.$children[0].setFitMarkers()
    },
    getSoilDetail (deviceNumber) {
      return this.$axios.get(this.$apis.iot.selectSoilInfoByDeviceNumber, {
        deviceNumber
      })
    },
    getWaterDetail (deviceNumber) {
      return this.$axios.get(this.$apis.iot.selectWaterInfoByDeviceNumber, {
        deviceNumber
      })
    },
    getElectricityDetail (deviceNumber) {
      return this.$axios.get(this.$apis.iot.selectJgCircuitBreakerInfoByDeviceNumber, {
        deviceNumber
      })
    },
    getLiuyaDetail (deviceNumber) {
      return this.$axios.get(this.$apis.iot.selectWaterLyInfoByDeviceNumber, {
        deviceNumber
      })
    },
    getDeviceDetail (info) {
      if (info.deviceType === 'A0') {
        return this.getSoilDetail(info.deviceNumber)
      } else if (info.deviceType === 'B0') {
        return this.getWaterDetail(info.deviceNumber)
      } else if (info.deviceType === 'C0') {
        return this.getElectricityDetail(info.deviceNumber)
      } else if (info.deviceType === 'AB') {
        return this.getLiuyaDetail(info.deviceNumber)
      }
    },
    getDeviceType (type) {
      let deviceType = ''
      switch (type) {
        case 'A0':
          deviceType = '1001'
          break
        case 'B0':
          deviceType = '1004'
          break
        case 'C0':
          deviceType = '1014'
          break
        case 'E0':
          deviceType = '1007'
          break
        case 'AB':
          deviceType = 'liuya'
          break
      }
      return deviceType
    },
    // 设备打点点击执行
    deviceMarkerClick (e) {
      const info = { ...e.target.extData }
      const deviceType = this.getDeviceType(info.deviceType)
      if (info.deviceType === 'E0') {
        this.detailInfo = { ...info, deviceType }
        this.$nextTick(() => {
          if (!this._bindPopup) {
            this._bindPopup = new vjmap.Popup({ closeButton: false })
          }
          this._bindPopup.setDOMContent(this.$refs.popupContent)
          e.target.setPopup(this._bindPopup)
          if (!this._bindPopup.isOpen()) {
            e.target.togglePopup()
          }
        })
      } else if (['A0', 'B0', 'C0', 'AB'].includes(info.deviceType)) {
        this.getDeviceDetail(info).then((res) => {
          this.detailInfo = { ...res, deviceType: deviceType }
          this.$nextTick(() => {
            if (!this._bindPopup) {
              this._bindPopup = new vjmap.Popup({ closeButton: false })
            }
            this._bindPopup.setDOMContent(this.$refs.popupContent)
            e.target.setPopup(this._bindPopup)
            if (!this._bindPopup.isOpen()) {
              e.target.togglePopup()
            }
          })
        })
      }
    },
    // 删除地图列表打点信息
    removeMarkers () {
      // 设置打点清除
      if (this._valveMarkers && this._valveMarkers.length) {
        this._valveMarkers.forEach(marker => {
          marker.off('click', this.valveMarkerClick)
          marker.remove()
        })
      }
      this._valveMarkers = []
      // 区域新增或编辑，初始化控制器设备清除
      if (this._initValveMarkers && this._initValveMarkers.length) {
        this._initValveMarkers.forEach(marker => {
          marker.remove()
        })
      }
      this._initValveMarkers = []
      // 区域新增或编辑，初始化土壤温湿设备清除
      if (this._initSoilMarkers && this._initSoilMarkers.length) {
        this._initSoilMarkers.forEach(marker => {
          marker.remove()
        })
      }
      this._initSoilMarkers = []
      // 区域新增或编辑，初始化智慧水表设备清除
      if (this._initWaterMarkers && this._initWaterMarkers.length) {
        this._initWaterMarkers.forEach(marker => {
          marker.remove()
        })
      }
      this._initWaterMarkers = []
      // 区域新增或编辑，初始化智慧电表设备清除
      if (this._initElectricityMarkers && this._initElectricityMarkers.length) {
        this._initElectricityMarkers.forEach(marker => {
          marker.remove()
        })
      }
      this._initElectricityMarkers = []
      // 区域设备信息打点清除
      if (this._areaDeviceMarkers && this._areaDeviceMarkers.length) {
        this._areaDeviceMarkers.forEach(marker => {
          marker.remove()
        })
      }
      this._areaDeviceMarkers = []
    },
    // 控制阀设备打点点击执行
    valveMarkerClick (e) {
      this.valveInfo = { ...e.target.extData }
      this.$nextTick(() => {
        if (!this._bindPopup) {
          this._bindPopup = new vjmap.Popup({ closeButton: false })
        }
        this._bindPopup.setDOMContent(this.$refs.popupContent)
        e.target.setPopup(this._bindPopup)
        if (!this._bindPopup.isOpen()) {
          e.target.togglePopup()
        }
      })
    },
    updateValveStatus (deviceInfo) {
      this._areaDeviceMarkers.forEach((item, ind) => {
        if (item.extData && item.extData.deviceNumber === deviceInfo.deviceNumber) {
          const lngLat = item.getLngLat()
          item.remove()
          const icon = require(`../../assets/img/icon/valve${deviceInfo.switchStatus !== '1' ? '_close' : ''}.png`)
          const el = this.getMarkerEl(icon, '36px', '48px')
          const marker = new vjmap.Marker({
            element: el,
            anchor: 'bottom'
          })
          marker.extData = { ...deviceInfo, deviceType: 'E0' }
          marker.setLngLat(lngLat).addTo(this._map)
          marker.on('click', this.deviceMarkerClick)
          this._areaDeviceMarkers[ind] = marker
        }
      })
    }
  }
}
</script>

<style scoped lang='scss'>
  .areaDevice-list {
    position: absolute;
    top: 78px;
    right: 6px;
    width: 360px;
    height: auto;
    padding: 20px;
    background: var(--right-bg-color);
    box-shadow: 0px 5px 16px 0px rgba(186,186,186,0.96);
    border-radius: 10px;
    .tabList {
      display: flex;
      width: 100%;
      padding: 1px 6px 0;
      background: var(--right-bg-tab);
      overflow: auto;
      margin-bottom: 10px;
      .tabItem {
        flex-shrink: 0;
        position: relative;
        font-family: PingFang SC;
        font-size: 12px;
        height: 26px;
        color: var(--font-color) !important;
        line-height: 26px;
        padding: 0 11px 0 7px !important;
        cursor: pointer;
        &::after {
          content: '';
          position: absolute;
          top: 0;
          right: 0px;
          width: 4px;
          height: 100%;
          background: var(--right-bg-tab);
        }
        &.active {
          position: relative;
          padding-right: 11px !important;
          background: var(--right-bg-tab-active);
          &::after {
            right: -4px;
            width: 8px;
            background: var(--right-bg-tab);
            transform: skewX(8deg);
          }
        }
      }
    }
    ::v-deep {
      .el-input, .el-input__inner {
        width: 100% !important;
        height: 28px;
        line-height: 28px;
        border-radius: 10px;
        margin-bottom: 10px;
      }
    }
    .tip {
      font-size: 12px;
    }
    .checkBlock {
      background: var(--right-bg-content);
      .line {
        border-top: 1px solid var(--right-border-content);
      }
      .el-checkbox {
        width: 100%;
        display: flex;
        align-items: center;
        padding: 12px 20px;
        margin-right: 0;
        ::v-deep .el-checkbox__label {
          width: 100%;
          font-size: 12px;
          color: var(--font-color);
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: keep-all;
          white-space: nowrap;
        }
      }
      .el-checkbox-group {
        padding: 10px 20px;
        .el-checkbox {
          padding: 6px 0px;
        }
      }
    }
  }
  .valve-marker-popup {
    width: 400px;
    min-height: 90px;
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 14px;
    background: var(--right-bg-color);
    box-shadow: 0px 5px 16px 0px rgba(186,186,186,0.96);
    border-radius: 10px;
    margin: 0px 20px 40px;
    .header{
      display: flex;
      height: auto;
      min-height: 34px;
      line-height: 14px;
      background: #2E3C55;
      border-radius: 10px 10px 0px 0px;
      padding: 10px 19px;
      color: #FFFFFF;
      p:nth-of-type(1){
        width: auto;
        max-width: 300px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
    .content{
      display: flex;
      color: var(--header-bar-title-color);
      padding: 16px 19px;
      font-size: 12px;
    }
    .iconfont {
      font-size: 12px;
      color: var(--color-primary);
      margin-left: 10px;
      &.icon-guanlian {
        font-size: 24px;
      }
      &.icon-guanbi1, &.icon-baocun1 {
        line-height: 24px;
      }
    }
  }
  .valve-bindDevice-popup {
    width: 400px;
    min-height: 150px;
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 14px;
    background: var(--right-bg-color);
    box-shadow: 0px 5px 16px 0px rgba(186,186,186,0.96);
    border-radius: 10px;
    margin: 0px 20px 40px;
    .header{
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 34px;
      background: #2E3C55;
      padding: 10px 19px;
      color: #FFFFFF;
      border-radius: 10px 10px 0 0;
    }
    .content{
      color: var(--header-bar-title-color);
      padding: 16px 0 0 19px;
    }
  }
  .device-info-popup {
    width: 400px;
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 14px;
    background: var(--right-bg-color);
    box-shadow: 0px 5px 16px 0px rgba(186,186,186,0.96);
    border-radius: 10px;
    margin: 0px 18px 48px;
  }
  .tip {
    color: var(--font-color);
  }
</style>
